import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { UserTypeEnum } from '../../types/user-type.ts';

const LazyConnectedAccounts = lazy(() => import('./ConnectedAccounts'));

const ConnectedAccounts = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const { user } = useAuth();
  return (
    <Suspense fallback={<PageLoading />}>
      {user?.userType === UserTypeEnum.DrugRep && <LazyConnectedAccounts {...props} />}
    </Suspense>
  );
};

export const connectedAccountsRoute = {
  path: '/connected-accounts',
  element: <ConnectedAccounts />,
};

export default ConnectedAccounts;
